async function devtricker_submitAjaxComment(postId, comment, parentId) {

    const formData = new FormData();

    formData.append('action', 'devtricker_comment_action_handle_submition_ajax');
    formData.append('post_id', postId);
    formData.append('comment', comment);
    formData.append('comment_parent', parentId);
    formData.append('nonce', await devtricker_process_getDevtrickerNonce());

    try {
        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        if (!response.ok) {

            let result = await response.text();
        
            throw new Error(result || `We couldn't process your comment.`);
        }

        let commentHtml = await response.text();

        return devtricker_extractCommentsFromPlainTextHtml(commentHtml);

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);

        throw error;
    }
}